import { useState, useEffect } from 'react';

export interface Post {
  id: number;
  name: string;
  message: string;
  timestamp: string;
}

const fetchPosts = async (): Promise<Post[]> => {
  const response = await fetch('/api/posts');
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

export function Posts() {
  const [posts, setPosts] = useState<Post[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  // 初回ロード
  useEffect(() => {
    fetchPosts()
      .then((data) => {
        setPosts(data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err);
        setLoading(false);
      });
  }, []);

  // WebSocket接続
  useEffect(() => {
    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    const ws = new WebSocket(`${protocol}//${window.location.host}/api/ws`);

    ws.onopen = () => {
      console.log('WebSocket connected');
    };

    ws.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        if (data.type === 'new-post') {
          const newPost: Post = data.post;
          setPosts((prevPosts) => {
            // 重複チェック
            if (prevPosts.some((p) => p.id === newPost.id)) {
              return prevPosts;
            }
            // 新しい投稿を先頭に追加
            return [newPost, ...prevPosts];
          });
        }
      } catch (err) {
        console.error('Failed to parse WebSocket message:', err);
      }
    };

    ws.onerror = (err) => {
      console.error('WebSocket error:', err);
    };

    ws.onclose = () => {
      console.log('WebSocket disconnected');
    };

    return () => {
      ws.close();
    };
  }, []);

  if (loading) {
    return <div className="p-5 text-center">読み込み中...</div>;
  }

  if (error) {
    throw error;
  }

  if (posts.length === 0) {
    return <div className="p-5 text-center">まだ投稿がありません</div>;
  }

  return (
    <>
      {posts.map((post) => (
        <article key={post.id} className="border-2 border-black mb-4 bg-gray-50 shadow-[2px_2px_0_rgba(0,0,0,0.2)]">
          <div className="bg-gray-200 px-3 py-2 border-b-2 border-black flex justify-between items-center">
            <div className="text-sm">
              <span className="font-bold text-green-700 mr-2.5">{post.name}</span>
              <span className="text-gray-600 text-xs">No.{post.id}</span>
            </div>
            <div className="text-xs text-gray-600">{post.timestamp}</div>
          </div>
          <div className="p-3 whitespace-pre-wrap break-words text-sm">{post.message}</div>
        </article>
      ))}
    </>
  );
}
